import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faUserEdit, faIdCard, faFilePen } from '@fortawesome/free-solid-svg-icons';

function Header({ username }) {
  const Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
  const Memberid = parseInt(sessionStorage.getItem("MemberID")) || null;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navLinkRef = useRef(null);

  const handleClick2 = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        navLinkRef.current &&
        !navLinkRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleClick = () => {
    document.body.classList.remove('mobile-nav-active');
    $('.mobile-nav-toggle i').toggleClass('icofont-close icofont-navigation-menu');
  };

  return (
    <header id="header" className="fixed-top">
      <div className="container d-flex">
        <div className="logo mr-auto">
          <h1 className="text-light">
            <NavLink to="/">
              <img src="/assets/img/logo/mensatrans.png" alt="" />
            </NavLink>
          </h1>
        </div>

        <nav className="nav-menu d-none d-lg-block">
          <ul>
            <li className="active"><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/AboutUs">About</NavLink></li>
            <li><NavLink to="/JoinUs">Join Us</NavLink></li>
            <li><NavLink to="/Spotlight">Spotlight</NavLink></li>
            <li><NavLink to="/Chapter">Chapter & SIG</NavLink></li>
            <li><NavLink to="/Contact">Contact</NavLink></li>

            {Memberid === null && (
              Candidateid === null ? (
                <li><NavLink to="/Candidatelogin">Candidate Login</NavLink></li>
              ) : (
                <li><NavLink to="/Profile" state={{ type: 'candidate' }}>Candidate Account</NavLink></li>
              )
            )}

            {/* Show Member login/account only if Candidate is NOT logged in */}
            {Candidateid === null && (
              Memberid === null ? (
                <li><NavLink to="/MemberLogin">Members Login</NavLink></li>
              ) : (
                <li><NavLink to="/Profile" state={{ type: 'member' }}>Member Account</NavLink></li>
              )
            )}
          </ul>
        </nav>

        <nav className="mobile-nav d-lg-none">
          <ul>
            <li className="active" onClick={handleClick}><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/AboutUs" onClick={handleClick}>About</NavLink></li>
            <li><NavLink to="/JoinUs" onClick={handleClick}>Join Us</NavLink></li>
            <li><NavLink to="/Spotlight" onClick={handleClick}>Spotlight</NavLink></li>
            <li><NavLink to="/Chapter" onClick={handleClick}>Chapter & SIG</NavLink></li>
            <li><NavLink to="/Contact" onClick={handleClick}>Contact</NavLink></li>

            {Candidateid === null ? (
              <li><NavLink to="/Candidatelogin" onClick={handleClick}>Candidate Login</NavLink></li>
            ) : (
              <li><NavLink to="/Profile" state={{ type: 'candidate' }} onClick={handleClick}>Candidate Account</NavLink></li>
            )}
            {Memberid === null ? (
              <li><NavLink to="/MemberLogin">Members Login</NavLink></li>
            ) : (
              <li><NavLink to="/Profile" state={{ type: 'member' }} onClick={handleClick}>Member Account</NavLink></li>
            )}

          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
